module.exports = __webpack_public_path__ + "Hotel-Morris-Ceska-Lipa.jpg?249bc8288118dc5df04b9f0ce0024f7e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/Hotel-Morris-Ceska-Lipa.jpg
// module id = 66
// module chunks = 0